import { ThunkDispatch } from "core-integration/src/store";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { UnstyledRACButton } from "plos/src/components/buttons/UnstyledRACButton";
import { ElementPhoto } from "plos/src/components/ElementPhoto";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getShortNameFromId, isBlankWeek } from "../../../../utils/events";
import {
  topElementName,
  topElementPhotoContainer,
  topElementStyles,
  topElementValue,
  topElementWrap,
} from "./eventTopElement.css";
import { EventTopElementProps } from "./types";

const EventTopElement = ({ element, event, points }: EventTopElementProps) => {
  const { t } = useTranslation("status");

  const dispatch = useDispatch<ThunkDispatch>();

  const showElementDialog = (elementId: number) => {
    dispatch(showElementSummary(elementId));
  };
  return (
    <div className={topElementWrap}>
      {element && !isBlankWeek(event.id) ? (
        <UnstyledRACButton
          onPress={() => showElementDialog(element.id)}
          className={topElementStyles}
        >
          <span className={topElementPhotoContainer}>
            <ElementPhoto elementId={element.id} alt={element.web_name} />
          </span>
          <span className={topElementName}>{element.web_name}</span>
          <span className={topElementValue}>
            <span>{getShortNameFromId(event.id)}</span>
            <span>{`${points} ${t("pts", "pts")}`}</span>
          </span>
        </UnstyledRACButton>
      ) : (
        <div className={topElementStyles}>
          <span className={topElementPhotoContainer}>
            <ElementPhoto alt={t("elementPhotoAlt", "Placeholder photo")} />
          </span>
          <div>
            <div className={topElementName}>-</div>
            <div className={topElementValue}>
              <span>{getShortNameFromId(event.id)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventTopElement;
